import { nonEmptyString, nonNegativeNumber, positiveInteger, positiveNumber } from "@/utils/form";
import { z } from "zod";
import { t } from "i18next";

export const AddPurchaseSchema = z.object({
  name: nonEmptyString(t("modals:addpurchase.inputs.name.label")),
  purchaseCost: positiveNumber(t("modals:addpurchase.inputs.purchasecost.label")),
  monthsDepreciation: positiveInteger(t("modals:addpurchase.inputs.monthsDepreciation.label")),
  yearlyMaintenance: nonNegativeNumber(t("modals:addpurchase.inputs.yearlymaintenance.label")),
  yearlyRepair: nonNegativeNumber(t("modals:addpurchase.inputs.yearlyrepair.label")),
  yearlyAdditionals: nonNegativeNumber(t("modals:addpurchase.inputs.yearlyadditionals.label")),
  quantity: positiveInteger(t("modals:addpurchase.inputs.quantity.label")),
  margin: nonNegativeNumber(t("modals:addpurchase.inputs.margin.label")), // Input as percentage, converted to BPS on submit
});

export const AddPurchaseDefaultValues = {
  name: "",
  purchaseCost: undefined,
  monthsDepreciation: "" as any, // force reset workaround
  yearlyMaintenance: undefined,
  yearlyRepair: undefined,
  yearlyAdditionals: undefined,
  quantity: "" as any, // force reset workaround
  margin: "" as any, // force reset workaround
};

export type TAddPurchaseSchema = z.infer<typeof AddPurchaseSchema>;
